import type {FlowBuilder} from 'src/types/flow-builder';
import type {FlowBuilderActions} from 'src/action-creators/flow-builder';

import {
  UPDATE_FLOW_BUILDER,
  RESET_FLOW_TEMPLATES,
  UPDATE_AGENT_SETTINGS,
} from 'src/action-creators/flow-builder';


export type FlowBuilderState = FlowBuilder;

const initialState = {
  templates: [],
  preview_template_id: null,
  template_name: null,
  // TODO(darsh): create a dummy workstream
  workstream: null,
  workstream_name: null,
  isWorkstreamLoading: false,
  agentSettings: {
    voiceBot: {
      selectedVoice: null,
      selectedBrand: null,
      selectedLanguage: null,
      selectedRole: null,
      responsiveness: null,
      voiceSpeed: null,
      speechNormalization: false,
    },
    voicemail: {
      voicemailDetection: false,
      voicemailAction: null,
      voicemailDuration: null,
      message: null,
    },
    additionalContext: {
      selectedIndustry: null,
      jobSpecialities: [],
    },
  },
} as const;

export default (
  // @ts-expect-error - TS2322 - Type '{ readonly templates: readonly []; readonly preview_template_id: null; readonly template_name: null; readonly workstream: null; readonly workstream_name: null; readonly isWorkstreamLoading: false; readonly agentSettings: { ...; }; }' is not assignable to type 'FlowBuilder'.
  state: FlowBuilderState | null | undefined = initialState,
  action: FlowBuilderActions,
): FlowBuilderState => {
  switch (action.type) {
    case UPDATE_FLOW_BUILDER: {
      // @ts-expect-error - TS2322 - Type '{ templates?: TemplateType[] | undefined; preview_template_id?: string | null | undefined; template_name?: string | null | undefined; workstream?: { [key: string]: unknown; } | null | undefined; workstream_name?: string | ... 1 more ... | undefined; isWorkstreamLoading?: boolean | undefined; agentSettings?: AgentSet...' is not assignable to type 'FlowBuilder'.
      return {
        ...state,
        ...action.payload,
      };
    }

    case RESET_FLOW_TEMPLATES: {
      // @ts-expect-error - TS2322 - Type '{ templates: never[]; preview_template_id: null; template_name?: string | null | undefined; workstream?: { [key: string]: unknown; } | null | undefined; workstream_name?: string | null | undefined; isWorkstreamLoading?: boolean | undefined; agentSettings?: AgentSettingsTypes | undefined; }' is not assignable to type 'FlowBuilder'.
      return {
        ...state,
        templates: [],
        preview_template_id: null,
      };
    }

    case UPDATE_AGENT_SETTINGS: {
      // @ts-expect-error - TS18047 - 'state' is possibly 'null'.
      const current = state.agentSettings || {};
      const payload = action.payload || {};

      // @ts-expect-error - TS2322 - Type '{ agentSettings: { voiceBot: { selectedVoice: string | null | undefined; selectedBrand: string | null | undefined; selectedLanguage: string | null | undefined; selectedRole: string | null | undefined; responsiveness: number | null | undefined; voiceSpeed: number | null | undefined; speechNormalization: boolean; }; v...' is not assignable to type 'FlowBuilder'.
      return {
        ...state,
        agentSettings: {
          voiceBot: {
            // @ts-expect-error - TS18048 - 'payload.agentSettings' is possibly 'undefined'.
            ...(payload.agentSettings.voiceBot ?? current.voiceBot ?? {}),
          },
          voicemail: {
            // @ts-expect-error - TS18048 - 'payload.agentSettings' is possibly 'undefined'.
            ...(payload.agentSettings.voicemail ?? current.voicemail ?? {}),
          },
          additionalContext: {
            // @ts-expect-error - TS18048 - 'payload.agentSettings' is possibly 'undefined'.
            ...(payload.agentSettings.additionalContext ??
              current.additionalContext ??
              {}),
          },
        },
      };
    }
  }
  // @ts-expect-error - TS2322 - Type 'FlowBuilder | null' is not assignable to type 'FlowBuilder'.
  return state;
};
